import { render, staticRenderFns } from "./MediumPosts.vue?vue&type=template&id=b198039a&scoped=true&"
import script from "./MediumPosts.vue?vue&type=script&lang=ts&"
export * from "./MediumPosts.vue?vue&type=script&lang=ts&"
import style0 from "./MediumPosts.vue?vue&type=style&index=0&id=b198039a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b198039a",
  null
  
)

export default component.exports